export const JoinMembershipTestIds = {
    page: 'join-membership-partner-page',
    mainScrollView: 'join-membership-partner-main-scroll',
    continueButton: 'join-membership-partner-continue',
} as const;
